var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('drawer',{attrs:{"title":"Media"},scopedSlots:_vm._u([{key:"header-primary",fn:function(){return undefined},proxy:true}])},[_c('navigation-tree',{attrs:{"item-type":"media"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }